"use strict";

require("core-js/modules/es.object.define-property.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.keysToCamelCase = exports["default"] = void 0;
var _camelCase = _interopRequireDefault(require("lodash/camelCase"));
var _transformKeys = _interopRequireDefault(require("./transformKeys"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
/**
 * Converts all keys in an object to camelCase format recursively
 * @param {Object} object - The object whose keys should be converted
 * @returns New object with camelCase keys
 */
var keysToCamelCase = exports.keysToCamelCase = function keysToCamelCase(object) {
  return (0, _transformKeys["default"])(object, _camelCase["default"]);
};
var _default = exports["default"] = keysToCamelCase;